<div class="modal fade" id="projectPermission" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">

  <div class="modal-dialog cascading-modal modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header darken-3 justify-content-center text-center text-white contactmodal">
        <h4 class="text-uppercase font-weight-bold text-center mx-5 pt-2">
          <i class="fa fa-calendar text-white   px-2"></i> Users Project Permission
        </h4>
        <button type="button" class="close waves-effect waves-light " data-dismiss="modal" aria-label="Close"
          (click)="dialogRef.close()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body" id="projectPermissionModalBody">

        <form [formGroup]="group" (submit)="submit()" (reset)="reset()" f="ngForm">
          <div class="md-form required">
            <p>App Type</p>
            <select class="browser-default custom-select form-control" formControlName="appType"
              [(ngModel)]="projectPermissionModal.appType" (change)="appTypeChanged(projectPermissionModal.appType)"
              (change)="clientTypeChanged('null')" #singleSelect autocomplete="off">
              <option value="">Select AppType</option>
              <select class="form-select">
                @for (at of appTypeList; track at.APPTYPE) {
                <option [value]="at.APPTYPE">
                  {{ at.APPTYPE }}
                </option>
                }
              </select>
            </select>
          </div>
          <div class="md-form required">
            <p>Client</p>
            <select class="browser-default custom-select form-control" required formControlName="clientType"
              [(ngModel)]="projectPermissionModal.clientId"
              (change)="clientTypeChanged(projectPermissionModal.clientId)" #singleSelect autocomplete="off">
              <option value="">Select Client</option>
              <select class="form-select">
                @for (cl of clients; track cl.CLIENT_ID) {
                <option [value]="cl.CLIENT_ID">
                  {{ cl.CLIENT_NAME }}
                </option>
                }
              </select>
            </select>
          </div>

          <div class="md-form required">
            <p>Project</p>
            <select class="browser-default custom-select form-control" formControlName="projectType"
              [(ngModel)]="projectPermissionModal.PROJECT_ID"
              (change)="projectTypeChanged(projectPermissionModal.PROJECT_ID, 'Y')" #singleSelect autocomplete="off">
              <option value="">Select Project</option>
              <select class="form-select">
                @for (project of projects; track project.PROJECT_ID) {
                <option [value]="project.PROJECT_ID">
                  {{ project.PROJECT_NAME }}
                </option>
                }
              </select>
            </select>
          </div>
          <div class="md-form required">
            <p>UserNames</p>
            <input class="form-control form-control-sm ml-3 w-45 userNamesList" type="text" formControlName="userIds"
              [(ngModel)]="projectPermissionModal.USER_NAME" placeholder="Enterprise Id's" aria-label="UserNames"
              mdbInput>
            <p>Note: Enterprise Id's Should be comma separated.</p>
          </div>
          <div class="md-form required">
            <input class="form-check-input excludeProjectUser" id="isExcludeProjUser" type="checkbox"
              formControlName="isExcludeProjectUser" (change)="OnCheckboxChanged()"
              [(ngModel)]="projectPermissionModal.isExcludeProjectUser" checked />
            <span class="ExcludeProjUsercheckbox">Exclude Project Users</span>
          </div>

          @if (hasData) {
          <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 tablename table-responsive"
            matSortDisableClear>
            @for (column of columns_to_display_in_table; track column) {
            @if (column !== 'Revoke') {
            <ng-container matColumnDef="{{ column }}">
              <th [hidden]="column=='USER_LOCATION'" mat-header-cell mat-sort-header *matHeaderCellDef
                class="header-align-right tableHeaderCustomized">
                {{ column }}
              </th>
              <td [hidden]="column=='USER_LOCATION'" mat-cell *matCellDef="let element">
                {{element[column]}}
              </td>
            </ng-container>
            }
            <tr class="mat-row NoDataFoundInTable" *matNoDataRow>
              <td class="mat-cell" colspan="9999">
                No data found
              </td>
            </tr>
            }
            <ng-container matColumnDef="Revoke">
              <th class="tableHeaderCustomized" mat-header-cell *matHeaderCellDef> ACTION </th>
              <td mat-cell *matCellDef="let element"> <a class="revokePermission" color="primary"
                  (click)="Revoke(element)">
                  Revoke
                </a></td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columns_to_display_in_table; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: columns_to_display_in_table"></tr>
          </table>
          }

          <div class="text-center">
            <button type="submit" class="btn basebtn text-uppercase contactbtn mr-3 waves-effect z-depth-0"
              [disabled]="!group.valid && !this.showSubmitButton">
              Save
            </button>
            <button type="reset" class="btn basebtn text-uppercase contactCancelbtn waves-effect z-depth-0">
              <i class="fas fa-window-close"></i>
              Reset
            </button>
          </div>
        </form>



      </div>
    </div>

  </div>

</div>